(function () {
  const root = document.querySelector("[data-org-slider]");
  if (!root) return;
  const dataEl = root.querySelector("[data-org-data]");
  let items = [];
  try {
    items = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  const photos = root.querySelectorAll(".org-photo");
  const tabs = root.querySelectorAll("[data-org-tab]");
  const title = root.querySelector("[data-org-title]");
  const body = root.querySelector("[data-org-body]");
  const pos = root.querySelector("[data-org-pos]");
  let i = 0;
  let paused = false;
  const n = items.length;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function pad(x) {
    return String(x).padStart(2, "0");
  }
  function go(next) {
    photos[i]?.classList.remove("is-active");
    tabs[i]?.classList.remove("is-active");
    i = (next + n) % n;
    photos[i]?.classList.add("is-active");
    tabs[i]?.classList.add("is-active");
    if (title) title.textContent = items[i].title;
    if (body) body.textContent = items[i].body;
    if (pos) pos.textContent = pad(i + 1) + " / " + pad(n);
  }
  go(0);
  tabs.forEach((t) => t.addEventListener("click", () => go(Number(t.getAttribute("data-org-tab")))));
  root.querySelector("[data-org-prev]")?.addEventListener("click", () => go(i - 1));
  root.querySelector("[data-org-next]")?.addEventListener("click", () => go(i + 1));
  root.addEventListener("mouseenter", () => (paused = true));
  root.addEventListener("mouseleave", () => (paused = false));
  if (!reduced) setInterval(() => { if (!paused) go(i + 1); }, 7000);
})();
